import { formatDayMonth } from '../../components/primitives';
import type { SidebarLayout } from '../../lib/sidebarLayout';
import { SIDEBAR_GROUPS, type SidebarGroup } from '../../../shared/prefs';

export const TABLE_LABELS: Record<string, string> = {
  knowledge_entries: 'System / template',
  meetings: 'Meeting',
  shoot_holds: 'Shoot hold',
  clients: 'Client',
  leads: 'Lead',
  projects: 'Project',
  tasks: 'Task',
  invoices: 'Invoice',
  expenses: 'Expense',
  crew_contacts: 'Crew contact',
  task_recurrences: 'Recurring task',
  journal_entries: 'Journal entry',
};

export const TRASH_WINDOW = 8;

export function deletedLabel(ms: number): string {
  const d = new Date(ms);
  const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  return `deleted ${formatDayMonth(iso)}`;
}

/** "13 Jun · 12:04" — local-time stamp (backups card, error log). */
export function timeLabel(uploadedIso: string): string {
  const d = new Date(uploadedIso);
  const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  return `${formatDayMonth(iso)} · ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

export function copySidebarLayout(layout: SidebarLayout): SidebarLayout {
  return Object.fromEntries(SIDEBAR_GROUPS.map((group) => [group, [...layout[group]]])) as SidebarLayout;
}

export function moveSidebarItem(
  layout: SidebarLayout,
  group: SidebarGroup,
  index: number,
  direction: 'up' | 'down',
): SidebarLayout {
  const next = copySidebarLayout(layout);
  const groupIndex = SIDEBAR_GROUPS.indexOf(group);
  const items = next[group];

  if (direction === 'up') {
    if (index > 0) {
      [items[index - 1], items[index]] = [items[index], items[index - 1]];
    } else if (groupIndex > 0) {
      const [item] = items.splice(index, 1);
      next[SIDEBAR_GROUPS[groupIndex - 1]].push(item);
    }
  } else if (index < items.length - 1) {
    [items[index], items[index + 1]] = [items[index + 1], items[index]];
  } else if (groupIndex < SIDEBAR_GROUPS.length - 1) {
    const [item] = items.splice(index, 1);
    next[SIDEBAR_GROUPS[groupIndex + 1]].unshift(item);
  }

  return next;
}
